export class SupplierModel {
  SupplierId: number = 0;
  SupplierName: string = '';
  ContactPersonName: string = '';
  Email: string = '';
  SupplierContactNumber: string = '';
  ContactPersonNumber: string = '';
  Address: string = '';
  Gst: string = '';
  City: string = '';
  State: string = '';
  Country: string = '';
  Pincode: string = '';
  // System-generated stable identity (SUP-00001…) used to map this supplier
  // to external applications such as SourceFlow. Read-only: the server
  // generates it on first save and never accepts a client value.
  SupplierCode: string = '';
  // Tally spelling: Regular / Composition / Regular - SEZ / Unregistered / Unregistered/Consumer / Consumer / Unknown
  GstRegistrationType: string = '';
  // Exact Tally party ledger this supplier posts to; blank falls back to the
  // supplier name at push time. Validated server-side against the synced
  // Tally ledger list.
  TallyLedgerName: string = '';
  // Soft-disabled: hidden from every dropdown feed, shown on the master page
  // (under the Disabled/All status filter) for re-enabling.
  Disabled: boolean = false;
  // Per-supplier opt-in for all supplier-facing notifications (post-QC,
  // delivery-delay, future channels). Tenant-level kill switch
  // ConfigTable.SupplierNotificationEnable still applies on top.
  IsEmailNotificationEnabled: boolean = false;
}

// One selectable Tally ledger for the Supplier Master picker, mirrored from
// tally/getunclaimedledgers.
export interface TallyLedgerOption {
  LedgerName: string;
  ParentGroupName: string;
  LastSyncedDate: string;
  /** Which Sundry group the ledger sits under; null when the server could not tell. */
  PartySide?: 'Creditors' | 'Debtors' | null;
  /**
   * Party details as the accounts team maintains them on the Tally ledger.
   * Picking the ledger copies these into the supplier so both systems carry one
   * tax identity. Any of them can be blank — a name-only creditor ledger is common.
   */
  MailingName?: string | null;
  Gstin?: string | null;
  GstRegistrationType?: string | null;
  Address?: string | null;
  StateName?: string | null;
  CountryName?: string | null;
  Pincode?: string | null;
}



export class CustomerModel {
  CustomerId: number = 0;
  CustomerName: string = '';
  CustomerContactNumber: string = '';
  Email: string = '';
  Address: string = '';
  Gstnumber: string = '';
  Country: string = '';
  State: string = '';
  AddedBy: string = '';
  AddedDate: string = '';
  IsEmailNotification: boolean = false;
  IsWhatsappNotification: boolean = false;
  CustomerShortName: string = '';
  CustomerCode: string = '';
  /** null = Default (subtype/tenant layers decide); 'Required' | 'Optional' override. */
  ProformaRequirement: string | null = null;

  // Customer notification subscriptions (mapped from NotificationGroupsTable)
  NotificationSubscriptions: CustomerNotificationSubscription[] = [];
}

export class CustomerNotificationSubscription {
  NotificationGroupUserId: number = 0; // From NotificationGroupsTable
  ConfigurationId: number = 0;
  NotificationTypeName: string = '';
  IsScheduleRequired: boolean = false;
  UseDefaultSchedule: boolean = true;
  CronScheduleExpression: string = '0 10 * * *'; // Default: 10 AM IST daily
  ScheduleDescription: string = 'Daily at 10:00 AM IST';
  PreferredNotificationTime: string = '10:00:00'; // TimeSpan as string
}


export class OrderModel {
  OrderId: number = 0;
  CustomerId: number = 0;
  SaleOrderNo: string = '';
  OrderType: string = '';
  CustomerName: string = '';
  OrderCreationDate: string = '';
  DeliveryDate: string = '';
  OrderProduct: OrderProductModel[] = [];
}

export class OrderProductModel {

  OrderProductId: number = 0;
  OrderId: number = 0;
  ProductCode: string = '';
  ProductId: number = 0;
  ProductName: string = '';
  ColorId: number = 0;
  ColorName: string = '';
  Width: number = 0;
  Thick: number = 0;
  Unit: string = '';
  Rate: number = 0;
  Quantity: number = 0;
  Grade: string = '';
}
